<template>
  <div class="context">
    <div class="header">
      <div class="btn_box">
        <div class="btn nomal_btn" @click="goBack">
          <i class="el-icon-back"></i>
          返回
        </div>
      </div>
      <div class="title">{{ viewTitle }}</div>
    </div>

    <div class="main_box">
      <div
        v-for="(item, index) in videoList"
        class="record_log_box"
        :key="index"
      >
        <div class="input_span">
          <el-input
            v-model="item.title"
            class="width_300"
            placeholder="请输入标题"
          ></el-input>
        </div>
        <div class="input_span">
          <el-input
            v-model="item.video_uid"
            class="width_200"
            placeholder="请输入视频ID"
          ></el-input>
        </div>
        <div class="input_span">
          <el-select v-model="item.cate" placeholder="请选择分类" class="width_200">
            <el-option
              v-for="item in videoClassifyList"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input_span">
          <el-select
            v-model="item.tags"
						class="width_200"
            multiple
            filterable
            allow-create
						collapse-tags
            default-first-option
            placeholder="请输入视频标签"
          >
            <el-option
              v-for="item in tagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-tag
            :key="tag"
            v-for="(tag, tag_index) in item.tags"
            closable
            :disable-transitions="false"
            @close="handleClose(item, tag_index)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm(item)"
            @blur="handleInputConfirm(item)"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ New Tag</el-button
          > -->
        </div>

        <div class="icon_span" @click="delRecord(index)">
          <i class="el-icon-remove-outline table_del_btn"></i>
        </div>
        <div
          class="icon_span"
          v-if="index == videoList.length - 1"
          @click="addRecord()"
        >
          <i class="el-icon-circle-plus-outline"></i>
        </div>
      </div>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueUeditorWrap from "vue-ueditor-wrap";
import config from "@/global/config";
import { clone } from "@/global/utils";

export default {
  name: "add",
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      viewTitle: "上传视频",
      inputVisible: false,
      inputValue: "",
        videoList: [
          {
            title: "",
            video_uid: "",
            cate: "",
            tags: [],
          },
        ],
      tagOptions: [],
    };
  },
  computed: {
    ...mapState("comInformationData", ["videoClassifyList"]),
  },
  mounted() {},
  methods: {
    goBack() {
      this.$emit("changeTopTab", "tableView");
    },
    delRecord(index) {
      if (this.videoList.length < 2) return;
      this.videoList.splice(index, 1);
    },
    addRecord() {
      let item = {
        title: "",
        video_uid: "",
        cate: "",
        tags: [],
      };
      this.videoList.push(item);
    },
    handleClose(item, tag_index) {
      item.tags.splice(tag_index, 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput[0].$refs.input.focus();
      });
    },
    handleInputConfirm(item) {
      let inputValue = this.inputValue;
      if (inputValue) {
        item.tags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm() {
      if (this.videoList.some((list) => !list.title || !list.video_uid)) {
        this.$message({
          message: "视频标题与视频ID为必填项!",
          showClose: true,
					type: 'warning'
        });
        return;
      }
      let params = {
        videos: this.videoList,
      };
      console.log("params", params);
			this.httpPost("/video", params).then((res) => {
				this.$message.success("添加成功！");
				this.goBack();
			});
    },
  },
};
</script>

<style scoped lang="scss">
$view_background: rgb(246, 247, 248);
$btn_border: rgb(246, 247, 248);
.context {
  width: 100%;
  height: 100%;
  background: $view_background;
  position: relative;
  z-index: 1;
  .header {
    width: 100%;
    line-height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid #ddd;
    /*color: #8d8d8d;*/
    .title {
    }
    .btn_box {
      padding-right: 20px;
      .btn {
        margin-top: 10px;
        border: 1px solid $btn_border;
      }
    }
  }
  .main_box {
    background: #fff;
    padding: 10px;
    height: calc(100% - 50px);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    .record_log_box {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .input_span {
        margin-right: 5px;
      }
      .icon_span {
        padding: 0 10px;
        font-size: 24px;
        cursor: pointer;
      }
    }
  }
}
</style>